/**
 * The Sentry `environment` for the web app (browser, server and edge).
 *
 * It used to be `process.env.NODE_ENV`, which is "production" on every Vercel build, PREVIEW builds
 * included. The ownly-jobs Sentry digest pages #alerts and opens an incident-fixer ticket for any new
 * issue in the "production" environment, so a crash on a throwaway preview copy would have paged
 * like a live outage. Vercel's own VERCEL_ENV tells the two apart.
 *
 * - live site (VERCEL_ENV=production)  -> "production"   (unchanged, existing issues keep grouping)
 * - Vercel preview deploys              -> "vercel-preview"
 * - `vercel dev`                        -> "vercel-development"
 * - anything else (laptop, box, CI)     -> "development"
 *
 * The browser bundle only sees NEXT_PUBLIC_ variables, inlined at build time, so next.config.ts
 * copies VERCEL_ENV into NEXT_PUBLIC_VERCEL_ENV. Both names are read with literal `process.env.X`
 * access so the bundler can inline them.
 */
export function sentryEnvironment(): string {
  const vercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV;
  if (vercelEnv === "production") return "production";
  if (vercelEnv === "preview") return "vercel-preview";
  if (vercelEnv === "development") return "vercel-development";
  return "development";
}
